exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MessageBar-module__wrapper___ft8zK{display:grid;grid-template-columns:1fr auto;gap:.5em}.MessageBar-module__wrapper___ft8zK input{background-color:#f2f2f2;border:none;width:100%;height:100%;padding:0 1em;margin-bottom:0;color:#0827e9;font-size:14px}.MessageBar-module__wrapper___ft8zK button{background-color:#0827e9;color:#fff;font-size:20px;width:45px;height:45px;border-radius:7px;border:none;transition:background-color .2s}.MessageBar-module__wrapper___ft8zK button:hover{background-color:#2c48f8}", ""]);

// exports
exports.locals = {
	"wrapper": "MessageBar-module__wrapper___ft8zK"
};